/**
 * Shopify Admin URL builders for live product / variant deep-links.
 */

export function extractShopifyNumericId(gid) {
  if (!gid || typeof gid !== 'string') return null;

  const lastSegment = gid.split('/').pop();
  if (!lastSegment || !/^\d+$/.test(lastSegment)) return null;

  return lastSegment;
}

export function getShopifyAdminStoreSlug(myshopifyDomain) {
  if (!myshopifyDomain || typeof myshopifyDomain !== 'string') return null;

  const trimmed = myshopifyDomain.trim();
  if (!trimmed) return null;

  const slug = trimmed.replace(/\.myshopify\.com$/i, '');
  return slug || null;
}

export function buildShopifyAdminProductUrl({ storeSlug, productStoreId } = {}) {
  if (!storeSlug) return null;

  const productId = extractShopifyNumericId(productStoreId);
  if (!productId) return null;

  return `https://admin.shopify.com/store/${storeSlug}/products/${productId}`;
}

export function buildShopifyAdminVariantUrl({
  storeSlug,
  productStoreId,
  variantStoreId,
} = {}) {
  if (!storeSlug) return null;

  const productId = extractShopifyNumericId(productStoreId);
  const variantId = extractShopifyNumericId(variantStoreId);
  if (!productId || !variantId) return null;

  return `https://admin.shopify.com/store/${storeSlug}/products/${productId}/variants/${variantId}`;
}
